import { render, staticRenderFns } from "./mail-authorization.vue?vue&type=template&id=1ec06b72&scoped=true&"
import script from "./mail-authorization.vue?vue&type=script&lang=js&"
export * from "./mail-authorization.vue?vue&type=script&lang=js&"
import style0 from "./mail-authorization.vue?vue&type=style&index=0&id=1ec06b72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec06b72",
  null
  
)

export default component.exports